<template>
  <div id="vueApp">
    <router-view/>
  </div>
</template>

<script>

import AOS from "aos";

export default {
  name: "App",

  async created() {
    AOS.init();
  },
  beforeMount() {
    if (this.$store.getters['user']) {
      this.$store.dispatch('refresh')
    }
  }

};
</script>

<style lang="scss">
@import "~aos/dist/aos.css";

html {
  font-size: 100%;
}

$rootPath: "../../../..";

@font-face {
  font-family: "AlternateGot";
  src: url(#{$rootPath}/css/fonts/AlternateGotNo1D.ttf);
}

@font-face {
  font-family: "AvenirBlack";
  src: url(#{$rootPath}/css/fonts/AvenirBlack.ttf);
}

@font-face {
  font-family: "Oswald";
  src: url(#{$rootPath}/css/fonts/oswald.light.ttf);
}

@font-face {
  font-family: "Questrial";
  src: url(#{$rootPath}/css/fonts/questrial-regular.ttf);
}

@font-face {
  font-family: "Avenir";
  src: url(#{$rootPath}/css/fonts/Avenir.ttf);
}

.form-input {
  @apply shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none;
}

.form-label {
  @apply block text-STblue font-bold mb-2;
}

.form-required:after {
  content: "*";
  color: black;
}
</style>
